<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      formData: {},
      registerActive: false,
      showPassword: false,
      resetPassword: "",
      addedUserData: null,
    };
  },

  computed: {
    isButtonDisabled() {
      if (this.formData.userpwd != this.formData.userpwd2) {
        return true
      } else if (!this.formData.userpwd || !this.formData.userpwd2) {
        return true
      } else {
        return false
      }
    }
  },

  methods: {
    ...mapActions("settings", ["getUserToken", "postUserToken", "registerToken"]),

    getUserInfo() {
      let temp = window.location.search.split("?token=");
      this.token = temp[1];
      let params = {
        token: this.token,
      };
      this.getUserToken(params)
        .then((res) => {
          this.addedUserData = res.data[0];
        })
        .catch(({ response }) => {
          // this.$router.push("/login");
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        });
    },
    postUserInfo() {
      let temp = window.location.search.split("?token=");
      this.token = temp[1];
      let params = {
        token: this.token,
        userpwd: this.formData.userpwd,
      };
      this.postUserToken(params)
        .then((res) => {
          this.$router.push("/login");
          this.$toast.open({
            message: this.$parseResMessage(res.data.messageName),
            type: "success",
            duration: 5000,
            dismissible: true,
          });
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        });
    },
    userToken() {
      const params = {
        token: window.location.search.split("?token="),
      }
      this.registerToken(params)
    },
    toLogin() {
      this.$router.push('/login')
    }
  },
  created() {
    this.getUserInfo();
  },
  watch: {},
};
</script>

<template>
  <div class="login-page">
    <div class="register-container">
      <div class="register-row" style="width: 75%">
        <div class="register-col">
          <div class="register-card">
            <img style="padding: 25px" src="/images/sustainfinity-logo.png" alt="sustainfinity-logo" />
            <div style="text-align: center">
              <p style="font-size: 200%; color: #61a60e">
                {{ $t("registerForm.hello") }} {{ addedUserData.firstname }}
                {{ addedUserData.surname }} !
              </p>
              <p>
                {{ $t('registerForm.added_to_team_text').replace('#C#', addedUserData.company_name).replace('#N#', addedUserData.creating_director) }}
              </p>
            </div>
            <p style="font-size: 120%; text-align: center;">
              {{ $t("registerForm.cartTitle") }}
            </p>
            <form @submit.prevent class="form-group" autocomplete="on">
              <div class="register-inputs">
                <input :value="`Email: ${addedUserData.email}`" type="text" class="register-input" disabled />
              </div>
              <div class="register-inputs">
                <input v-model="formData.userpwd" :type="showPassword ? 'text' : 'password'" class="register-input"
                  :placeholder="$t('registerPass.password')" required autocomplete="new-password" />
                <div class="password-icon-container">
                  <i class="fa-regular fa-eye show-password-icon" @click="showPassword = !showPassword"
                    v-if="showPassword == false"></i>
                  <i class="fa-regular fa-eye-slash show-password-icon" @click="showPassword = !showPassword"
                    v-if="showPassword == true"></i>
                </div>
              </div>
              <br />
              <div class="register-inputs">
                <input v-model="formData.userpwd2" :type="showPassword ? 'text' : 'password'" class="register-input"
                  :placeholder="$t('registerPass.password_again')" required autocomplete="new-password" />
                <div class="password-icon-container">
                  <i class="fa-regular fa-eye show-password-icon" @click="showPassword = !showPassword"
                    v-if="showPassword == false"></i>
                  <i class="fa-regular fa-eye-slash show-password-icon" @click="showPassword = !showPassword"
                    v-if="showPassword == true"></i>
                </div>
              </div>
              <br />
              <button class="register-submit" style="font-size: larger;" @click="postUserInfo()"
                :disabled="isButtonDisabled" :class="{ 'disabled': isButtonDisabled }"> {{ $t("registerForm.save") }}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.register-container {
  position: fixed;
  top: 50%;
  left: 75%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 400px;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  margin: auto;
}

.register-row {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
}

.register-col {
  width: 75vh;
  max-width: 500px;
  padding: 20px;
  border-radius: 10px;
}

.register-card {
  padding: 20px;
  border-radius: 5px;
  text-align: center;
  border: 2px solid rgb(214, 212, 212);
  max-width: 400px;
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 400px;
  background-color: transparent;
}

.register-inputs {
  position: relative;
  display: flex;
  align-items: center;
  padding: 5px;
  margin-bottom: 5px;
}

.register-input {
  width: 100%;
  padding: 10px;
  border: none;
  font-size: 16px;
  padding-right: 35px;
  border-radius: 5px;
  border: 1px solid transparent;
  transition: all 0.3s ease-in-out;
}

.register-input:focus {
  border: 1px solid #0383ab;
  box-shadow: 0 0 5px 2px rgba(116, 177, 243, 0.973);
}

.register-input:disabled {
  background-color: rgba(196, 196, 196, 0.518);
}

.eye-button {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  font-size: 16px;
  top: 50%;
  transform: translateY(-50%);
}

.register-submit {
  width: 100%;
  background-color: #61a60e;
  color: white;
  padding: 12px;
  border: 1px solid transparent;
  border-radius: 5px;
  cursor: pointer;
  font-size: large;
  text-align: center;
  transition: background-color 0.3s ease;
  text-transform: uppercase;
  font-weight: bold;
}


.register-submit:hover {
  background-color: #229863;
}

.register-submit:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  border: 1px solid #28a745;
}

@media (max-width: 320px) {
  .register-container {
    width: 100%;
    max-width: 320px;
    padding: 10px;
  }

  .register-row {
    flex-direction: column;
    align-items: center;
  }

  .register-col {
    width: 100%;
    padding: 0px;
  }

  .register-card {
    padding: 10px;
    width: 100%;
    max-width: 300px;
    min-height: auto;
  }

  .register-input {
    font-size: 12px;
    padding: 6px;
  }

  .register-submit {
    font-size: 12px;
    padding: 8px;
  }

  .eye-button {
    right: 5px;
    font-size: 12px;
  }
}

.password-icon-container {
  position: absolute;
  z-index: 10;
  right: .75em;
  top: 50%;
  transform: translateY(-50%);
}

.show-password-icon:hover {
  cursor: pointer;
  filter: brightness(125%);
  z-index: 99;
}
</style>
